import React from 'react'
import { XIcon } from '@phosphor-icons/react'
import { Tribe } from '../../types/Tribe'
import { Role } from '../../types/Roles'
import { FormCheckbox } from './FormCheckbox'

interface NotificationSettingsModalProps {
  tribes: Tribe[]
  guilds: Role[]
  tempSelectedTribeIds: number[]
  tempSelectedGuildIds: number[]
  onTempTribeIdsChange: (ids: number[]) => void
  onTempGuildIdsChange: (ids: number[]) => void
  onClose: () => void
  onSave: () => void
}

export const NotificationSettingsModal = ({
  tribes,
  guilds,
  tempSelectedTribeIds,
  tempSelectedGuildIds,
  onTempTribeIdsChange,
  onTempGuildIdsChange,
  onClose,
  onSave,
}: NotificationSettingsModalProps) => (
  <div className="employee-form__modal-overlay" role="dialog">
    <div className="employee-form__modal">
      <div className="employee-form__modal-header">
        <h2 className="employee-form__modal-title">
          Time Off Notification Email
        </h2>
        <button
          type="button"
          className="employee-form__modal-close"
          onClick={onClose}
          aria-label="Close"
        >
          <XIcon size={20} weight="regular" />
        </button>
      </div>
      <div className="employee-form__modal-body">
        <p className="employee-form__modal-intro">
          You can customize select which Tribes and Guilds to receive
          notification of. I would like to receive information of:
        </p>
        <div className="employee-form__modal-group">
          <p className="employee-form__modal-group-title">Select Tribes:</p>
          <div className="employee-form__modal-list">
            {tribes.map(tribe => (
              <FormCheckbox
                key={`notif-tribe-${tribe.id}`}
                id={`notif-tribe-${tribe.id}`}
                small
                checked={tempSelectedTribeIds?.includes(tribe.id)}
                label={tribe.name}
                onChange={checked => {
                  checked
                    ? onTempTribeIdsChange([...tempSelectedTribeIds, tribe.id])
                    : onTempTribeIdsChange(
                        tempSelectedTribeIds?.filter(
                          tribeId => tribeId != tribe.id,
                        ),
                      )
                }}
              />
            ))}
          </div>
        </div>
        <div className="employee-form__modal-group">
          <p className="employee-form__modal-group-title">Select Guilds:</p>
          <div className="employee-form__modal-list">
            {guilds.map(guild => (
              <FormCheckbox
                key={`notif-guild-${guild.id}`}
                id={`notif-guild-${guild.id}`}
                small
                checked={tempSelectedGuildIds?.includes(guild.id)}
                label={guild.role}
                onChange={checked => {
                  checked
                    ? onTempGuildIdsChange([...tempSelectedGuildIds, guild.id])
                    : onTempGuildIdsChange(
                        tempSelectedGuildIds?.filter(
                          guildId => guildId != guild.id,
                        ),
                      )
                }}
              />
            ))}
          </div>
        </div>
        <div className="employee-form__modal-footer">
          <button
            type="button"
            className="employee-form__btn employee-form__btn--cancel"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="employee-form__btn employee-form__btn--submit"
            onClick={onSave}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
)
